// Documents Module Types

export enum DocumentCategory {
  BYLAWS = 'BYLAWS',
  MINUTES = 'MINUTES',
  FINANCIAL = 'FINANCIAL',
  NOTICES = 'NOTICES',
  INSURANCE = 'INSURANCE',
  OTHER = 'OTHER'
}

export interface CommunityDocument {
  id: string;
  title: string;
  category: DocumentCategory;
  uploadDate: string;
  url: string;
  size?: string;
  uploadedBy: string;
  fileId?: string;
  mimeType?: string;
  /** Secciones a las que aplica (§6.5). Vacío u omitido = todo el residencial. */
  sectionIds?: string[];
}
